import { Component } from '@angular/core';

@Component({
  selector: 'app-site-add-page',
  templateUrl: './site-add-page.component.html',
  styleUrls: ['./site-add-page.component.scss'],
})
export class SiteAddPageComponent {}
